import * as React from 'react';
import styled from 'styled-components';
import { BREAK_POINTS } from '../consts/style';

interface ContainerProps {
  'data-comment'?: string;
  baseSideMargin?: number;
  last?: true;
  verticalOffset?: number;
}

export interface IVerticalOffset {
  verticalOffset?: number;
}

export const Container = styled.div`
  padding: 0;
  margin: 8px ${(p: ContainerProps) => p.baseSideMargin || 8}px;
  max-width: 1140px;
  left: 0;
  right: 0;
  z-index: 1000;

  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    margin: 0 16px ${(p: ContainerProps) => (p.last ? 8 : 32)}px;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    margin: ${(p: ContainerProps) => p.verticalOffset || 0}px auto
      ${(p: ContainerProps) => (p.last ? 8 : 32)}px;
    position: relative;
  }
`;

export interface FlexContainerProps {
  verticalOffset?: number;
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'initial'
    | 'inherit';
  margin?: boolean;
  direction?: string;
}

export const FlexContainer = styled(Container).attrs({
  'data-comment': 'FlexContainer',
})`
  display: flex;
  justify-content: ${(p: FlexContainerProps) => p.justify};
  flex-direction: ${(p: FlexContainerProps) => p.direction || 'row'};

  @media (max-width: ${BREAK_POINTS.MAX.MD}) {
    flex-wrap: wrap;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    margin: ${(p: FlexContainerProps) => p.verticalOffset || 0}px 16px 16px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    box-sizing: border-box;
    margin: ${(p: FlexContainerProps) => p.verticalOffset || 0}px auto 32px;
  }
  @media (min-width: 1140px) {
    margin: ${(p: FlexContainerProps) => p.verticalOffset || 0}px auto 32px;
  }

  & {
    ${(p: FlexContainerProps) => (p.margin ? 'margin-bottom: 0;' : '')};
  }
`;

interface StretchDivProps {
  color?: string;
  last?: boolean;
}

const StretchDiv = (styled.div as any).attrs({
  'data-comment': 'StretchContainer',
})`
  width: 100%;
  background-color: ${(p: StretchDivProps) => p.color || 'white'};


  ${Container} {
    @media (min-width: ${BREAK_POINTS.MIN.SM}) {
      margin: 0 auto ${(p: StretchDivProps) => (p.last ? 8 : 32)}px;
    }
    @media (max-width: 1170px) and (min-width: ${BREAK_POINTS.MIN.MD}) {
      padding: 0 15px;
    }
    @media (max-width: ${BREAK_POINTS.MAX.MD}) {
      padding: 0;
    }
  }
`;

const StretchDigitalAdoptionDiv = (styled.div as any).attrs({
  'data-comment': 'StretchContainer',
})`
  width: 100%;
  background-color: ${(p: StretchDivProps) => p.color || 'white'};
        margin: 0 auto 8px;
    overflow: hidden;

    @media (min-width: ${BREAK_POINTS.MIN.SM}) {
      margin: 0 auto 16px;
    }
    @media (min-width: ${BREAK_POINTS.MIN.MD}) {
      margin: 0 auto 32px;
    }

`;

export const DigitalAdoptionContainer = (styled.div as any).attrs({
  'data-comment': 'Container',
})`
  padding: 0;
  margin: 8px ${(p: ContainerProps) => p.baseSideMargin || 8}px;
  max-width: 1140px;
  left: 0;
  right: 0;
  z-index: 1000;
  
  margin:auto;
`;

const StretchMidPageCompaignDiv = (styled.div as any).attrs({
  'data-comment': 'StretchContainer',
})`
  width: 100%;
  background-color: ${(p: StretchDivProps) => p.color || 'white'};
        margin: 0 auto 8px;
    overflow: hidden;

    @media (min-width: ${BREAK_POINTS.MIN.SM}) {
      margin: 0 auto 8px;
    }
    @media (min-width: ${BREAK_POINTS.MIN.MD}) {
      margin: 0 auto 8px;
    }

`;

export const StretchContainer = ({ children, ...props }) => {
  return (
    <StretchDiv {...props}>
      <Container {...props}>{children}</Container>
    </StretchDiv>
  );
};

export const StretchDigitalAdoptionContainer = ({ children, ...props }) => {
  return (
    <StretchDigitalAdoptionDiv {...props} Container>
      <DigitalAdoptionContainer {...props}>{children}</DigitalAdoptionContainer>
    </StretchDigitalAdoptionDiv>
  );
};

export const StretchMidPageCompaignContainer = ({ children, ...props }) => {
  return (
    <StretchMidPageCompaignDiv {...props} Container>
      <DigitalAdoptionContainer {...props}>{children}</DigitalAdoptionContainer>
    </StretchMidPageCompaignDiv>
  );
};
